import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';
import {
  runBannerPublishJob,
  runTemplatePublishJob,
  runPartnersPublishJob,
  runBrandsPublishJob,
  runDepartmentsPublishJob,
  runCareersPublishJob,
  runCareerApplicationsPublishJob,
  runOurTeamPublishJob,
  runProjectsPublishJob,
  runPagesPublishJob,
  runCategoriesPublishJob,
  runWidgetsPublishJob,
  runSeoPublishJob,
  runInformationPolicyPublishJob,
  runAdminSettingsPublishJob,
  runConfigSettingsPublishJob,
} from 'helpers/formPublishJobs';

export const runPublishJob = ({ job, files, accessToken, onProgress, signal }) => {
  switch (job.contentType) {
    case PUBLISH_CONTENT_TYPES.BANNER:
      return runBannerPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.TEMPLATE:
      return runTemplatePublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.PARTNERS:
      return runPartnersPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.BRANDS:
      return runBrandsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.DEPARTMENTS:
      return runDepartmentsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.CAREERS:
      return runCareersPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.CAREER_APPLICATIONS:
      return runCareerApplicationsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.OUR_TEAM:
      return runOurTeamPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.PROJECTS:
      return runProjectsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.PAGES:
      return runPagesPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.CATEGORIES:
      return runCategoriesPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.WIDGETS:
      return runWidgetsPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.SEO:
      return runSeoPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.INFORMATION_POLICY:
      return runInformationPolicyPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.ADMIN_SETTINGS:
      return runAdminSettingsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.CONFIG_SETTINGS:
      return runConfigSettingsPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    default:
      throw new Error('Unsupported publish job type.');
  }
};
